module.exports = __webpack_public_path__ + "static/media/33-2.b12d01a5.mp3";